import { svg as shopifySvg } from 'thesvg/shopify';
import { svg as woocommerceSvg } from 'thesvg/woocommerce';
import { svg as squarespaceSvg } from 'thesvg/squarespace';
import { svg as wordpressSvg } from 'thesvg/wordpress';
import { svg as cloudflareSvg } from 'thesvg/cloudflare';
import { svg as polygonSvg } from 'thesvg/polygon';
import { svg as stripeSvg } from 'thesvg/stripe';
import { svg as metamaskSvg } from 'thesvg/metamask';
import { svg as trustWalletSvg } from 'thesvg/trust-wallet';
import { svg as krakenSvg } from 'thesvg/kraken';
import { svg as bitcoinSvg } from 'thesvg/bitcoin';
import { svg as blockchaindotcomSvg } from 'thesvg/blockchaindotcom';
import { svg as supabaseSvg } from 'thesvg/supabase';
import { svg as circleSvg } from 'thesvg/circle';
import { svg as githubSvg } from 'thesvg/github';
import { svg as visaSvg } from 'thesvg/visa';
import { svg as mastercardSvg } from 'thesvg/mastercard';
import { svg as americanExpressSvg } from 'thesvg/american-express';
import { svg as applePaySvg } from 'thesvg/apple-pay';
import { svg as googlePaySvg } from 'thesvg/google-pay';
import { svg as ethereumSvg } from 'thesvg/ethereum';

const BRAND_SVGS: Record<string, string> = {
  shopify: shopifySvg,
  woocommerce: woocommerceSvg,
  squarespace: squarespaceSvg,
  wordpress: wordpressSvg,
  cloudflare: cloudflareSvg,
  polygon: polygonSvg,
  stripe: stripeSvg,
  metamask: metamaskSvg,
  'trust wallet': trustWalletSvg,
  kraken: krakenSvg,
  bitcoin: bitcoinSvg,
  blockchain: blockchaindotcomSvg,
  supabase: supabaseSvg,
  usdc: circleSvg,
  github: githubSvg,
  visa: visaSvg,
  mastercard: mastercardSvg,
  'american express': americanExpressSvg,
  amex: americanExpressSvg,
  'apple pay': applePaySvg,
  'google pay': googlePaySvg,
  ethereum: ethereumSvg,
};

export function getBrandSvg(name: string): string | null {
  return BRAND_SVGS[name.toLowerCase()] ?? null;
}

interface BrandIconProps {
  name: string;
  className?: string;
  size?: number;
}

export default function BrandIcon({ name, className = '', size = 24 }: BrandIconProps) {
  const svg = getBrandSvg(name);
  if (!svg) return null;

  return (
    <span
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
